import { apiClient } from '@/services/apiClient';
import type { AgendaItemDto, AgendaStatus } from '../types';

export async function listAgenda(params?: { from?: string | undefined; to?: string | undefined; status?: AgendaStatus | undefined; type?: string | undefined; hasLocation?: boolean | undefined }) {
  const qs = new URLSearchParams();
  if (params?.from) qs.set('from', params.from);
  if (params?.to) qs.set('to', params.to);
  if (params?.status) qs.set('status', params.status);
  if (params?.type) qs.set('type', params.type);
  if (params?.hasLocation !== undefined) qs.set('hasLocation', String(params.hasLocation));
  return apiClient.get<{ items: AgendaItemDto[] }>(`/agenda?${qs.toString()}`);
}

export async function createAgenda(item: Partial<AgendaItemDto>) {
  return apiClient.post<AgendaItemDto>('/agenda', item);
}

export async function updateAgenda(id: string, patch: Partial<AgendaItemDto>) {
  return apiClient.patch<AgendaItemDto>(`/agenda/${id}`, patch);
}

export async function moveAgendaDate(id: string, startAt?: string, endAt?: string) {
  return apiClient.post<AgendaItemDto>(`/agenda/${id}/move-date`, { startAt, endAt });
}

export async function moveAgendaStatus(id: string, status: AgendaStatus) {
  return apiClient.post<AgendaItemDto>(`/agenda/${id}/status`, { status });
}

export async function deleteAgenda(id: string) {
  return apiClient.delete(`/agenda/${id}`);
}
